// extracted by mini-css-extract-plugin
export default {"category__title":"styles_category__title__0U2A2","category__items":"styles_category__items__nmDYA"};